/**
 * SolutionsAppStoreHero — the `/solutions/app-store` design.
 *
 * Verbatim render of `solutions-app-store.html`. Modules in
 * ./landing/solutions-app-store/. Includes the AppStore search filter
 * and the FAQ accordion, both driven by the file's own inline script.
 */
import { STYLES } from "./landing/solutions-app-store/styles";
import { MARKUP } from "./landing/solutions-app-store/markup";
import { SCRIPT } from "./landing/solutions-app-store/script";
import { PageHost } from "./landing/PageHost";

export function SolutionsAppStoreHero() {
  return (
    <PageHost
      styles={STYLES}
      markup={MARKUP}
      script={SCRIPT}
      hostClass="trex-appstore-host"
      wireLinks={true}
      data-testid="solutions-app-store-hero"
    />
  );
}
